(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["scrolling-banner"] && !window.DesignMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function() {
    document.fonts.ready.then(() => document.querySelector('.marquee').classList.add('marquee--animate'));
    document.querySelectorAll('.lazyload').forEach((el) => {lazySizes.loader.unveil(el);});
  });

  } catch(e) { console.error(e); }
})();
      })();
